import axios from '@services/axios'
import apiService from '@services/apiService'

export * from './interface'

const prefix = '/learn/app/'
export default {
  getHomeList(): Promise<any> {
    return axios.get(`${prefix}clientapi/home/pc/queryUserHomeList.do`)
  },
  getGlobalTimestamp(): Promise<any> {
    return axios.post(
      `${prefix}getGlobalTimestamp.do`,
      {},
      {
        params: { noInterceptorCancel: true },
      }
    )
  },
  /** 获取当前时间 */
  getTimestamp(): Promise<any> {
    return apiService.post(
      `${prefix}getGlobalTimestamp.do`,
      {},
      {},
      {
        params: { noInterceptorCancel: true },
      }
    )
  },
  othersPersonDetail(searchedUserId: string) {
    return axios.get(`${prefix}othersPersonDetail.do`, {
      params: {
        searchedUserId,
      },
    })
  },
}
